import { styled, Typography } from '@mui/material';
import React from 'react';

export const DEFAULT_FIELD_CONTENT_HEIGHT = 36;

interface LabelProps {
    text: React.ReactNode;
    inheritColor?: boolean;
    noMargin?: boolean;
}

export const Label = ({ text, inheritColor, noMargin }: LabelProps) => (
    <Typography
        variant='body2'
        color={inheritColor ? 'inherit' : 'textPrimary'}
        style={{ userSelect: 'none', marginBottom: noMargin ? '0px' : '4px' }}>
        {text}
    </Typography>
);

const FieldBase = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
});

const FieldContent = styled('div', {
    shouldForwardProp: prop => prop !== '$contentHeight',
})<{ $contentHeight: number }>(({ $contentHeight }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    minHeight: $contentHeight,
}));

export interface FieldProps {
    label?: React.ReactNode;
    required?: boolean;
    children: React.ReactNode;
    contentHeight?: number;
}

export const Field = ({
    label,
    required,
    children,
    contentHeight = DEFAULT_FIELD_CONTENT_HEIGHT,
}: FieldProps) => (
    <FieldBase>
        {label && <Label text={required ? <>{label} *</> : label} />}
        <FieldContent $contentHeight={contentHeight}>{children}</FieldContent>
    </FieldBase>
);
